import "../../../styles/Shared.css";
import "../../../styles/Modals.css";
import './ReviewConflictsModalDataLine.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FiAlertCircle } from "react-icons/fi"


import DatePicker from "react-datepicker";
import { subYears } from "date-fns";

import { ModalStates } from './ReviewConflictModalStates';
import { IsErrorState, GetInputValidationErrorText } from "../UpdateEntityModals/InputValidation";
import { useEffect, useState } from "react";
import { calculateConceptualAge } from "../../../utilities/ConceptualAgeUtilities";
import CalculateDateOfConception from "../../../utilities/CalculateDateOfConception";


function ReviewConflictsModalDataLineConceptualAge(props) {

  const [conceptualAge, setConceptualAge] = useState(null); // error state for birth date input, if needed in the future

  // Recalculate conceptual age when gestational age changes
  useEffect(() => {
    calculateConceptualAgeFromBirthDate(props.birthDate, props.gestationalAge);
  }, [props.gestationalAge]);

  function handleBirthDateChange(date) {
    props.setBirthDate(date);

    calculateConceptualAgeFromBirthDate(date, props.gestationalAge);
  }

  function calculateConceptualAgeFromBirthDate(birthDate, gestationalAge) {
    if (!birthDate || !gestationalAge) return;

    const conceptualWeeks = calculateConceptualAge(birthDate, parseFloat(gestationalAge)).toFixed(2);
    setConceptualAge(conceptualWeeks);
    const dateOfConception = CalculateDateOfConception(conceptualWeeks);
    props.updateDateOfConception(dateOfConception, conceptualWeeks);
  }

  function getDataRowIconStyle(hasConflict, modalState) {
    switch (modalState) {
      case ModalStates.Review:
      case ModalStates.Merge:
        return hasConflict === true ? 'DataRowIcon' : 'InvisibleCollapse';
      case ModalStates.ConfirmMerge:
        return hasConflict === true ? 'DataRowIconDisabled' : 'InvisibleCollapse';
      case ModalStates.ConfirmEdit:
        return 'InvisibleCollapse';
      case ModalStates.Edit:
        return 'InvisibleCollapse';
      default:
        return 'InvisibleCollapse';
    }
  }

  function getDataLabelStyle(hasConflict, modalState) {

    switch (modalState) {
      case ModalStates.Review:
      case ModalStates.Merge:
        return hasConflict === true ? 'HighlightedDataLabel' : 'NormalDataLabel';
      case ModalStates.Edit:
      case ModalStates.ConfirmEdit:
        return 'NormalDataLabel';
      case ModalStates.ConfirmMerge:
        return 'NormalDataLabel';
      default:
        return 'InvisibleCollapse';
    }
  }

  function getDataValueStyle(hasConflict, modalState) {


    switch (modalState) {
      case ModalStates.Review:
      case ModalStates.Merge:
        return hasConflict === true ? 'HighlightedDataValue' : 'NormalDataValue';
      case ModalStates.Edit:
        return 'NormalDataValue';
      case ModalStates.ConfirmEdit:
        return 'NormalDataValue';
      case ModalStates.ConfirmMerge:
        return 'NormalDataValue';
      default:
        return 'InvisibleCollapse';
    }
  }

  function getErrorMessageStyle(errorState) {
    if (props.modalState !== ModalStates.Edit) {
      return 'InvisibleCollapse';
    }

    // TODO: also base on modal state.
    return IsErrorState(errorState) ? 'InputValidationErrorMessage' : 'InvisibleCollapse';
  }

  return (
    <>
      <Row>

        <Col className="col-sm-1">
          
            <FiAlertCircle className={getDataRowIconStyle(props.conflict, props.modalState)} />

        </Col>
        <Col className="col-sm-4">

          <span className={getDataLabelStyle(props.conflict, props.modalState)}>{props.labelName.toUpperCase()}</span>
          <br></br>
          {props.subName && (
            <span className="secondary-text">{props.subName}</span>
          )}
        </Col>
        <Col className="col-sm-3">

          <label className={getDataValueStyle(props.conflict, props.modalState)}>

            {props.originalPatientParameter} {props.originalUnits}
          </label>

          <label className={getErrorMessageStyle(props.originalPatientErrorState)}>
            {GetInputValidationErrorText(props.originalPatientErrorState, props.labelName)}
          </label>
        </Col>
        <Col className="col-sm-3">

          <label className={getDataValueStyle(props.conflict, props.modalState)}>
            {props.patientParameter}{props.editedUnits}
          </label>

          <label className={getErrorMessageStyle(props.patientErrorState)}>
            {GetInputValidationErrorText(props.patientErrorState, props.labelName)}
          </label>
        </Col>
      </Row>



      {props.modalState === ModalStates.Merge && props.conflict === true &&

        <Row>
          <Col className="col-sm-5"></Col>
          <Col className="col-sm-7">
            <div>
              <label className="AddEntityModalLabel mt-2" htmlFor='birthdate-input'>BIRTH DATE</label>
              <DatePicker
                showIcon
                className={IsErrorState(props.errorState) ? 'AddEntityModalEntryError ' : 'AddEntityModalEntry'}
                selected={props.birthDate}
                id='birthdate-input'
                onChange={handleBirthDateChange}
                maxDate={new Date()}
                minDate={subYears(new Date(), 5)}
                placeholderText="Select birth date"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                onKeyDown={(e) => e.preventDefault()}
                wrapperClassName="w-100"
              />

              <label className={IsErrorState(props.errorState) ? 'InputValidationErrorMessage' : 'InvisibleCollapse'}>
                {GetInputValidationErrorText(props.errorState, 'Birth date')}
              </label>

              <p className="mt-1 mb-2 neo_gen_text">Note: For HIPAA compliance, the birth date entered here will not be stored. It is used only temporarily to calculate the conceptual age.</p>

              {props.birthDate && props.gestationalAge &&
                <>
                  <label className="AddEntityModalLabel mt-2" htmlFor='birthdate-input'>CONCEPTUAL AGE</label>
                  <input className="AddEntityModalEntry"
                    id={`${props.labelName}-input`}
                    disabled={true}
                    type={'text'}
                    value={`${conceptualAge} weeks (as of ${new Date().toLocaleDateString()})` ?? ""} />
                </>
              }
            </div>
          </Col>
        </Row>
      }

    </>


  );
}

export default ReviewConflictsModalDataLineConceptualAge;